import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import LoginView from "../views/LoginView.vue";
import ScheduleView from "../views/ScheduleView.vue";
import LogoutView from "../views/LogoutView.vue";
import CompaniesView from "../views/CompaniesView.vue";
import SecurityOfficersView from "../views/SecurityOfficersView.vue";
import ChangePassword from "../views/ChangePassword.vue"
import SitesView from "../views/SitesView.vue"
import SiteScheduleView from "../views/SiteScheduleView.vue"
import JobCallsView from "../views/JobCallsView.vue"
import ExpiryDatesScanView from "../views/ExpiryDatesScanView.vue"
import PaysView from "../views/PaysView.vue"



const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    redirect: "/login"  // This redirects root to /login
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: LoginView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/schedule",
    name: "schedule",
    component: ScheduleView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/jobCalls",
    name: "jobCalls",
    component: JobCallsView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/siteSchedule",
    name: "siteSchedule",
    component: SiteScheduleView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path: "/logout",
    name: "logout",
    component: LogoutView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },

  },
  {
    path: "/securityOfficers",
    name: "securityOfficers",
    component: SecurityOfficersView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props: { baseUrl: "https://localhost:44325/" },
    //props: { baseUrl: "https://emergingsols2.somee.com/" },
  },
  {
    path:"/changepassword",
    name:"changepassword",
    component: ChangePassword,
    props:{baseUrl: localStorage.getItem("baseUrl"), userId:11},
    //props:{baseUrl: "https://localhost:44325/", userId:11},
    //props:{baseUrl: "https://emergingsols2.somee.com/", userId:0},
  },
  {
    path:"/sites",
    name:"sites",
    component:SitesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
  },
  {
    path:"/companies",
    name:"companies",
    component:CompaniesView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/expiryDatesScan",
    name:"expiryDatesScan",
    component:ExpiryDatesScanView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  },
  {
    path:"/pays",
    name:"pays",
    component:PaysView,
    props:{baseUrl: localStorage.getItem("baseUrl")},
    //props:{baseUrl: "https://localhost:44325/"},
    //props:{baseUrl: "https://emergingsols2.somee.com/"},  
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
